<template>
  <el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2" label-position="left" label-width="0px" class="demo-ruleForm login-container">
    <h3 class="title">推送系统登录</h3>
    <el-form-item prop="account">
      <el-input type="text" v-model="ruleForm2.account" auto-complete="off" placeholder="账号"></el-input>
    </el-form-item>
    <el-form-item prop="checkPass">
      <el-input type="password" v-model="ruleForm2.checkPass" auto-complete="off" placeholder="密码"></el-input>
    </el-form-item>
    <el-checkbox v-model="checked" checked class="remember">记住密码</el-checkbox>
    <el-form-item style="width:100%;">
      <el-button type="primary" style="width:100%;" @click.native.prevent="handleSubmit2" :loading="logining">登录</el-button>
      <!--<el-button @click.native.prevent="handleReset2">重置</el-button>-->
    </el-form-item>
  </el-form>
</template>

<script>
 import { requestLogin,requestMenu} from '../api/api';
  //import NProgress from 'nprogress'
  export default {
    data() {
      return {
        logining: false,
        ruleForm2: {
          account: '',
          checkPass: ''
        },
        rules2: {
          account: [
            { required: true, message: '请输入账号', trigger: 'blur' },
            //{ validator: validaePass }
          ],
          checkPass: [
            { required: true, message: '请输入密码', trigger: 'blur' },
            //{ validator: validaePass2 }
          ]
        },
        checked: true
      };
    },
    methods: {
      handleReset2() {
        this.$refs.ruleForm2.resetFields();
      },
      handleSubmit2(ev) {
        var _this = this;
        this.$refs.ruleForm2.validate((valid)=>{
          if (valid) {
            
            this.logining = true;
            this.$http.jsonp(requestLogin, {params: {username: this.ruleForm2.account, password: this.ruleForm2.checkPass,SysType:3 }}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
                           sessionStorage.setItem('user', JSON.stringify(res.data.user));           
                           sessionStorage.setItem("userID",res.data.user.user_id);
                           sessionStorage.setItem("session",res.data.user.session);
                          // this.$router.push({ path: '/home' });


                           if (this.checked)
                           {
                              // localStorage.setItem("userID",res.data.user.user_id);
                              // localStorage.setItem("account",this.ruleForm2.account);
                              // localStorage.setItem("checkPass",this.ruleForm2.checkPass);

                              
                               sessionStorage.setItem('account',this.ruleForm2.account);
                               sessionStorage.setItem('checkPass',this.ruleForm2.checkPass)
               

                           }


                           
                    this.$http.jsonp(requestMenu,{params: {CurrentUserID: res.data.user.user_id,SysType:3,Session:res.data.user.session }}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
                               
							                 res.data.menu.splice(0, 0, {"menu_id":0,"menu_code":"","parent_code":"","title": "首页","path": "/home","icon":"el-icon-menu",children: []})
                              
                               sessionStorage.setItem("menu",JSON.stringify(res.data.menu));

                               this.$store.state.menu=res.data.menu;
                              this.$router.push({ path: '/home' });

                        
                         }
                         else{                           
                              
                                  if (res.data.result_code==911)
                                  {
                                                    this.$router.push({ path: "/login"});
                                    return;
                                  }

                                                if (res.data.result_code==600)
                                  {
                                    this.$message({
                                      message:'接口错误',
                                      type: 'error'
                                    });
                                                    return;
                                  }
							
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'接口访问失败',
                                type: 'error'
                              });
                      
                   }
           )
                         }
                         else{                           
                              this.$message({
                                message:'用户名或密码错误',
                                type: 'error'
                              });

                              this.logining = false;
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'访问失败',
                                type: 'error'
                              });
                      this.logining = false;
                   }
           )

   
          } else {
            //console.log('error submit!!');
            return false;
          }
        });
      }
    },
   		mounted() {
			// if (localStorage.getItem('account'))
      // {
      //   this.ruleForm2.account=localStorage.getItem('account')
      // }
      // if (localStorage.getItem('checkPass'))
      // {
      //   this.ruleForm2.checkPass=localStorage.getItem('checkPass')
      // }


      if (sessionStorage.getItem('account'))
      {
        this.ruleForm2.account=sessionStorage.getItem('account')
      }
      if (sessionStorage.getItem('checkPass'))
      {
        this.ruleForm2.checkPass=sessionStorage.getItem('checkPass')
      }
			
		}
  }

</script>

<style lang="scss" scoped>
  .login-container {
    /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin: 180px auto;
    width: 350px;
    padding: 35px 35px 15px 35px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
    .title {
      margin: 0px auto 40px auto;
      text-align: center;
      color: #505458;
    }
    .remember {
      margin: 0px 0px 35px 0px;
    }
  }
</style>


// WEBPACK FOOTER //
// login.vue?b7fdc1e0